(() => {
  class IzyContactLauncher extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.button = this.querySelector('button');
      this.frame = null;
      this.initialChecks = 0;
      this.refresh = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      document.addEventListener('visitorConsentCollected', this.refresh);
      document.addEventListener('dialog:after-hide', this.refresh, true);
      document.addEventListener('close', this.refresh, true);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'class', 'style', 'hidden', 'data-izy-localization-pending'] });
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.initialCheckTimer);
      document.removeEventListener('visitorConsentCollected', this.refresh);
      document.removeEventListener('dialog:after-hide', this.refresh, true);
      document.removeEventListener('close', this.refresh, true);
    }
    update() {
      if (!this.button?.isConnected) return;
      const queue = window.IzyPopupQueue;
      clearTimeout(this.initialCheckTimer);
      if ((!queue || queue.privacy === 'loading') && this.initialChecks++ < 50) this.initialCheckTimer = setTimeout(this.refresh, 200);
      const modalId = this.dataset.modalId;
      const otherActive = queue?.active && queue.active.element.id !== modalId;
      const otherDialog = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][open], .pswp--open')).some(element => element.id !== modalId);
      // Keep our trigger available behind its own modal so Prestige can restore keyboard focus.
      const blocked = !window.Shopify?.designMode && (!queue || document.documentElement.hasAttribute('data-izy-localization-pending') || queue.cookiePending() || otherActive || otherDialog);
      const hidden = Boolean(blocked);
      if (this.button.hidden !== hidden) this.button.hidden = hidden;

    }
  }
  if (!customElements.get('izy-contact-launcher')) customElements.define('izy-contact-launcher', IzyContactLauncher);
})();
